module.exports = __webpack_public_path__ + "static/expertise-4718526866489c681812ba8c7f50f882.svg";